import React from 'react';
import ReactDOM from 'react-dom';
import ReactModalFileEdit from '../modal/modal';

class FileEditBtn extends React.Component {
    constructor(props) {
        super(props);
    }

    showModalReact() {
        ReactDOM.render(<ReactModalFileEdit {...this.props} />, document.getElementById('dialog'))
    }

    render() {
        return (
            <button onClick={(e) => this.showModalReact(e)}
                    type="button" className="btn btn-info btn-xs edit-files"
                    data-toggle="tooltip"
                    data-placement="top" title="Редактировать файл" data-trigger="hover">
                <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span>
            </button>
        );
    }
}
export default FileEditBtn;